"use strict";Object.defineProperty(exports, "__esModule", {value: true});var Features; (function (Features) {
  const VIDEO_CHAT = 'VIDEO_CHAT'; Features["VIDEO_CHAT"] = VIDEO_CHAT;
  const PATIENT_MESSAGING = 'PATIENT_MESSAGING'; Features["PATIENT_MESSAGING"] = PATIENT_MESSAGING;
  const ADVANCED_SEARCH = 'ADVANCED_SEARCH'; Features["ADVANCED_SEARCH"] = ADVANCED_SEARCH;
  const TEST_SEARCH_ITERATORS = "TEST_SEARCH_ITERATORS"; Features["TEST_SEARCH_ITERATORS"] = TEST_SEARCH_ITERATORS;
  const BLOOM_VIDEO_V2 = 'BLOOM_VIDEO_V2'; Features["BLOOM_VIDEO_V2"] = BLOOM_VIDEO_V2;
  const CREATE_NEW = 'CREATE_NEW'; Features["CREATE_NEW"] = CREATE_NEW;
  // The inbox pills' and sidebar's numbers (GetInboxCounts). Off, the apps
  // never ask for them.
  const INBOX_COUNTS = 'INBOX_COUNTS'; Features["INBOX_COUNTS"] = INBOX_COUNTS;
  // The account layer, read from the account's default org (D-88). The apps
  // learn whether an org's account is flagged from GetAccount.
  const ACCOUNTS = 'ACCOUNTS'; Features["ACCOUNTS"] = ACCOUNTS;
  // The customer audit log, read from the account's default org. The apps
  // learn whether an account records it from GetAccount (AuditLog).
  const AUDIT_LOG = 'AUDIT_LOG'; Features["AUDIT_LOG"] = AUDIT_LOG;
  // Forms: the Library, Send a form and the Sent tab, per org.
  const FORMS = 'FORMS'; Features["FORMS"] = FORMS;
  // Consent to text: the org's Consent tab, the profile's Consent row and
  // "asked again" on Resubscribe.
  const CONSENT = 'CONSENT'; Features["CONSENT"] = CONSENT;
  // Keyword auto-replies, the welcome line and Requests, per org.
  const KEYWORDS = 'KEYWORDS'; Features["KEYWORDS"] = KEYWORDS;
  // Account › Reports for Owners and IT, read from the default org (D-88).
  const REPORTS = 'REPORTS'; Features["REPORTS"] = REPORTS;
  // Clinic branding: a verified org's logo, icon, colour and contact card
  // on patient links and in the patient app, and team logos.
  const BRANDING = 'BRANDING'; Features["BRANDING"] = BRANDING;
})(Features || (Features = {}));

exports. default = Features
